// @ts-nocheck
/**
 * htmlRenderer.ts — Template V2 'html' embed component renderer.
 *
 * Resolves the component's `html.source` ValueSource to a raw string and emits
 * a descriptor with `props.content`. The string is normalized / sanitized at the
 * paint boundary (app node renderer) and again at public-share bake — the
 * renderer itself stays pure and host-agnostic.
 *
 * No React/RN imports; output is a plain serializable RenderDescriptor.
 */

import { applyExpressionFallback, buildDescriptor, resolveValue } from './rendererUtils';
import type { CompiledPropsByType, ComponentRenderer } from './types';
import { extractTypedProps } from './types';

export const HTML_RENDERER: ComponentRenderer<CompiledPropsByType['html']> = {
  supportedType: 'html',
  render(context) {
    const issuesBefore = context.issues.length;
    const { visible, enabled } = applyExpressionFallback(context);
    const p = extractTypedProps('html', context.node.props);
    const raw = p.html?.source ? resolveValue(p.html.source, context) : null;
    const content = typeof raw === 'string' ? raw : null;

    return buildDescriptor(
      context.node,
      visible,
      enabled,
      {
        content,
        fit: p.html.fit ?? 'fill',
        fallback: p.html.fallback ?? 'placeholder',
      },
      { diagnostics: context.issues.slice(issuesBefore), renderContext: context },
    );
  },
};
